// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"900520df","518":"7042b759","556":"1cac8d25"}[chunkId] + ".chunk.js";
};